function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.529785,
  width: 55,
  height: 55,
  rx: 8.25,
  fill: "#EAF9F3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.1819 19.1537C30.4094 19.1537 32.5423 20.0377 34.1168 21.6135C35.6894 23.1885 36.5744 25.3259 36.5744 27.5553C36.5744 32.1954 32.8169 35.9542 28.1814 35.9542C25.9565 35.9564 23.8219 35.0711 22.2465 33.4943C20.6738 31.9194 19.7893 29.7829 19.7893 27.5553C19.7893 25.3254 20.6734 23.188 22.2465 21.6135C23.8223 20.0377 25.957 19.1519 28.1819 19.1537ZM28.1819 15.2778C16.9647 15.2778 10.4604 24.4819 10.4604 27.5553C10.4604 30.6277 16.9647 39.8296 28.1819 39.8296C39.4027 39.8296 45.9042 30.6277 45.9042 27.5553C45.9042 24.4824 39.4027 15.2778 28.1819 15.2778Z",
  fill: "#76BEA4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.3907 27.5556C33.3907 30.0679 31.61 32.2285 29.1451 32.7058C26.6802 33.1836 24.2231 31.8437 23.2858 29.5127C22.3489 27.1808 23.196 24.5114 25.3052 23.1487C27.4135 21.7833 30.194 22.1085 31.9306 23.9225L28.149 27.5561H33.3907V27.5556Z",
  fill: "#76BEA4"
});

function SvgApprovalRateGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalRateGreen);
export default __webpack_public_path__ + "static/media/approval_rate_green.29b67a55.svg";
export { ForwardRef as ReactComponent };